import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Field, Form, FormGroup, Radio, RadioGroup } from '@availity/form';
import '@availity/yup';
import { SelectField } from '@availity/select';
import { DateField } from '@availity/date';
import { Row, Col, Button, Label, UncontrolledTooltip } from 'reactstrap';
import * as yup from 'yup';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReimbursementStore from '../stores/ReimbursementStore';
import withNavigate from '../../Common/components/withNavigate';


@observer
 class LandingPage extends Component {

    componentDidMount () {
        // keep the user on the same page on browser back button/arrow click
        window.onpopstate = () => {
            this.props.navigate(1);
        }
    }

  
  submit = () => {
        const { navigate } = this.props;
        navigate('/reimbursementform');
    }

    render() {

       

        return (
            <>
                <div className="border-form">
            
                   
                    <Form
                         onSubmit={this.submit}
                        enableReinitialize
                        initialValues={{
                           
                        }}
                        validationSchema={yup.object().shape({
                            
                        })}
                    >
                        <div>
                            <p>The Foundational Community Supports (FCS) Transition Assistance Program (TAP) provides flexible, time-limited funding assistance to FCS 
                                supportive housing enrollees with behavioral health treatment needs who are in the process of moving. FCS TAP helps cover fees that are 
                                often barriers to renting a home, including but not limited to IDs, application fees, move-in costs, and more. </p>
                        </div>
                        <div className="spacer-24" />
                        
                        <div className="spacer-48" />
                        <div className="button-container">
                        <b className='button-text'>Submit this form to request TAP funding for your FCS enrollee making a housing transition.</b>
                        <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
                            Start Request
                        </Button>
                        </div>
                        
                        

                      

                        <div className="pb-spacerRem-10" />

                    </Form>
                </div>
            </>
        );
    }
}
export default withNavigate(LandingPage);

LandingPage.propTypes = {
    navigate: PropTypes.func
};